<template>
  <a :href="project.link" class="card" target="_blank" rel="noopener noreferrer">
    <div class="thumb" :style="{ backgroundImage: `url(${project.thumbnail})` }" aria-hidden="true">
      <span class="shine" aria-hidden="true"></span>
    </div>
    <div class="overlay">
      <h3 class="title">{{ project.name }}</h3>
    </div>
  </a>
</template>

<script setup>
const props = defineProps({ project: Object })
</script>

<style scoped>
.card {
  display: block;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  color: inherit;
  transition: transform .18s ease, box-shadow .18s ease;
}
.card:hover { transform: translateY(-6px); box-shadow: 0 18px 40px rgba(12,18,30,0.22); }

.thumb {
  width: 100%;
  padding-top: 66.66%; /* 3:2 aspect */
  background-size: cover;
  background-position: center;
  position: relative;
  filter: saturate(1.02);
}

.card::before {
  /* subtle glass layer */
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0));
  backdrop-filter: blur(6px) saturate(1.05);
  mix-blend-mode: overlay;
  pointer-events: none;
}

.overlay {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  display: flex;
  align-items: center;
}

.title {
  background: rgba(255,255,255,0.06);
  padding: 6px 10px;
  border-radius: 999px;
  backdrop-filter: blur(6px);
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.18) inset;
}

.shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0.06) 35%, rgba(255,255,255,0) 60%);
  transform: translateX(-120%);
  animation: glide 3.2s linear infinite;
  mix-blend-mode: screen;
  opacity: 0.9;
  pointer-events: none;
}

@keyframes glide { to { transform: translateX(120%); } }
</style>